import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import { checkAuthAndRedirect, isAdmin } from './utils/auth';
import './scss/playerMatches.scss';
import api from './services/apiService';

function PlayerMatches() {
    const navigate = useNavigate();
    const [players, setPlayers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('all'); // 'all', 'paid', 'unpaid'

    useEffect(() => {
        // Check if user is admin
        if (!isAdmin()) {
            navigate('/dashboard');
            return;
        }

        checkAuthAndRedirect(navigate);
        fetchPlayerMatches();
    }, [navigate]);

    const fetchPlayerMatches = async () => {
        try {
            const response = await api.get(`${process.env.REACT_APP_API_URL}/get_player_matches.php`);
            const data = response.data;
            
            if (data.success) {
                setPlayers(data.players);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching player matches:', error);
            setLoading(false);
        }
    };

    const filteredPlayers = players.map(player => ({
        ...player,
        matches: player.matches.filter(match => {
            if (filter === 'all') return true;
            if (filter === 'paid') return match.payment_status === 'paid';
            if (filter === 'unpaid') return match.payment_status !== 'paid';
            return true;
        })
    })).filter(player => player.matches.length > 0);

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    return (
        <div className="player-matches container">
            <Header />
            <div>
                <button className="back-button" onClick={() => window.history.back()}>← Back</button>
                <h1>Player Matches & Payments</h1>
            </div>
            <div className="filter-controls">
                <button 
                    className={filter === 'all' ? 'active' : ''} 
                    onClick={() => setFilter('all')}
                >
                    All
                </button>
                <button 
                    className={filter === 'paid' ? 'active' : ''} 
                    onClick={() => setFilter('paid')}
                >
                    Paid
                </button>
                <button 
                    className={filter === 'unpaid' ? 'active' : ''} 
                    onClick={() => setFilter('unpaid')}
                >
                    Unpaid
                </button>
            </div>
            
            <div className="players-list">
                {filteredPlayers.map(player => (
                    <div key={player.player_id} className="player-card">
                        <div className="player-header">
                            <h2>{player.first_name}</h2>
                            <div className="player-summary">
                                <span>Total Matches: {player.summary.total_matches}</span>
                                <span>Paid: {player.summary.paid_matches}</span>
                                <span>Unpaid: {player.summary.unpaid_matches}</span>
                                {player.summary.total_owed > 0 && (
                                    <span className="amount-owed">Owed: £{player.summary.total_owed}</span>
                                )}
                            </div>
                        </div>
                        <div className="matches-grid">
                            <div className="grid-header">
                                <span>Date</span>
                                <span>Goals</span>
                                <span>Amount</span>
                                <span>Payment Status</span>
                            </div>
                            {player.matches.map(match => (
                                <div key={match.match_id} className="match-row">
                                    <span>{new Date(match.date).toLocaleDateString()}</span>
                                    <span>{match.goals || 0}</span>
                                    <span>£{match.payment_amount || '5'}</span>
                                    <span className={`payment-status ${match.payment_status || 'pending'}`}>
                                        {match.payment_status ? (
                                            <>
                                                {match.payment_status.charAt(0).toUpperCase() + match.payment_status.slice(1)}
                                                {match.payment_date && (
                                                    <span className="payment-date">
                                                        {new Date(match.payment_date).toLocaleDateString()}
                                                    </span>
                                                )}
                                            </>
                                        ) : 'Pending'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default PlayerMatches; 